import "./Home.module.css";
import ApexNavigation from "@/reusable_sections/Header";
import ReachYourAcademicPeak from "./sections/ReachYourAcademicPeak";
import TheProofOfProgress from "./sections/TheProofOfProgress";
import ProvenScoreDeltas from "./sections/ProvenScoreDeltas";
import CoreMasteryTracks from "./sections/CoreMasteryTracks";
import StartYourAscent from "./sections/StartYourAscent";
import ApexFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ApexNavigation />
      <ReachYourAcademicPeak />
      <TheProofOfProgress />
      <ProvenScoreDeltas />
      <CoreMasteryTracks />
      <StartYourAscent />
      <ApexFooter />
    </div>;
}